<template>
    <v-expansion-panel v-if="disabled">
        <v-expansion-panel-header> {{ title }} </v-expansion-panel-header>

        <v-expansion-panel-content><slot></slot></v-expansion-panel-content>
    </v-expansion-panel>
    <div v-else style="padding-bottom: 1rem; width: 100%">
        <h4 style="padding-bottom: 1rem">{{ title }}</h4>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: ["disabled", "title"],
};
</script>
